// AI商务定制功能，所有路由都以/ai开头
export default [
// AI员工
    { path: "/ai-quote/quotation/robot-employee", meta: { title: "AI员工" }, component: () => import("@/views/h5/ai/robotEmployee/QywxChatRobotEmployees.vue") },
    { path: "/ai-quote/quotation/groups", meta: { title: "群管理" }, component: () => import("@/views/h5/ai/chatGroup/QywxChatGroups.vue") },
    { path: "/ai-quote/quotation/key-words", meta: { title: "聊天关键字" }, component: () => import("@/views/h5/ai/chatKeyWord/QywxChatKeyWords.vue") },
    { path: "/ai-quote/quotation/solution", meta: { title: "推荐方案" }, component: () => import("@/views/h5/ai/solution/ProductSolution.vue") },
    { path: "/ai-quote/quotation/solution/detail", meta: { title: "推荐方案管理" }, component: () => import("@/views/h5/ai/solution/ProductSolutionDetail.vue") },
    { path: "/customer-service/member", meta: {title: "ERP客户关联关系"}, component: () => import("@/views/h5/ai/erpCustomerRelation/ErpCustomerRelationList.vue")},

];
